<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-gauge-high"></i></div>
      <div>
        Tableau de bord
        <div class="page-title-subheading">Vue d'ensemble de l'établissement</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<!-- Indicateurs : seuls ceux accordes au profil sont renvoyes par l'API.
     La tuile entiere est cliquable quand une page correspond, plutot qu'un
     lien separe. -->
<div class="row g-3 mb-4">
  <div class="col-6 col-md-4 col-xl-3" *ngFor="let t of tiles()">

    <a *ngIf="t.route" [routerLink]="t.route" class="dash-tile">
      <div class="d-flex align-items-center gap-3">
        <div class="dash-tile-icon"><i class="fa-solid {{t.icon}}"></i></div>
        <div>
          <div class="dash-tile-value">{{t.value}}</div>
          <div class="dash-tile-label">{{t.label}}</div>
        </div>
      </div>
    </a>

    <div *ngIf="!t.route" class="dash-tile">
      <div class="d-flex align-items-center gap-3">
        <div class="dash-tile-icon"><i class="fa-solid {{t.icon}}"></i></div>
        <div>
          <div class="dash-tile-value">{{t.value}}</div>
          <div class="dash-tile-label">{{t.label}}</div>
        </div>
      </div>
    </div>

  </div>

  <div class="col-12" *ngIf="loaded && tiles().length===0">
    <div class="alert alert-light border mb-0">
      Aucun indicateur n'est configuré pour votre profil.
    </div>
  </div>
</div>

<div class="row g-3">
  <div class="col-12" [class.col-lg-8]="showOnboarding()" *ngIf="hasChart()">
    <div class="card h-100">
      <div class="card-header"><strong>Évolution des inscriptions</strong></div>
      <div class="card-body" style="height: 320px;">
        <canvas baseChart
                [data]="lineChartData"
                [options]="lineChartOptions"
                type="line"></canvas>
      </div>
    </div>
  </div>

  <!-- Raccourcis de demarrage : administrateur systeme uniquement, et
       seulement tant que l'etablissement n'a pas d'eleves. -->
  <div class="col-12" [class.col-lg-4]="hasChart()" *ngIf="showOnboarding()">
    <div class="card h-100">
      <div class="card-header"><strong>Prise en main</strong></div>
      <div class="list-group list-group-flush">
        <a routerLink="/admin/users" class="list-group-item list-group-item-action">
          <i class="fa-solid fa-user-plus ag-text-yellow me-2" aria-hidden="true"></i>
          <strong>Ajouter des utilisateurs</strong>
          <div class="small text-muted">Créer des comptes et leur attribuer un rôle.</div>
        </a>
        <a routerLink="/admin/configurations/classrooms" class="list-group-item list-group-item-action">
          <i class="fa-solid fa-chalkboard ag-text-yellow me-2" aria-hidden="true"></i>
          <strong>Ajouter des classes</strong>
          <div class="small text-muted">Déclarer les classes de l'établissement.</div>
        </a>
        <a routerLink="/admin/configurations/courses" class="list-group-item list-group-item-action">
          <i class="fa-solid fa-book-open ag-text-yellow me-2" aria-hidden="true"></i>
          <strong>Ajouter des matières</strong>
          <div class="small text-muted">Définir les matières enseignées.</div>
        </a>
        <a routerLink="/admin/inscription-create" class="list-group-item list-group-item-action">
          <i class="fa-solid fa-user-graduate ag-text-yellow me-2" aria-hidden="true"></i>
          <strong>Inscrire un premier élève</strong>
          <div class="small text-muted">Ouvrir le dossier d'un apprenant.</div>
        </a>
      </div>
    </div>
  </div>
</div>
